import React from 'react';
import { Input } from 'semantic-ui-react';
import styled from 'styled-components';
import debounce from '../../../utils/debounce';

const SearchInput = ({
  isLoad,
  getSearchItem,
  page = 1,
  type,
  setSearchValue,
  choosedTagsIds = [],
  placeholder = 'Поиск по шаблонам/папкам...',
}) => {
  const handleChangeSearchTemplates = debounce((text) => {
    if (text.length > 2 || text === '') {
      setSearchValue(text);
      if (type) {
        getSearchItem(type, text, page, choosedTagsIds);
      } else getSearchItem(text, page, choosedTagsIds);
    }
  }, 700);

  if (isLoad) {
    return <Spinner />;
  }

  return (
    <Input
      style={{ width: '100%' }}
      onChange={(e) => handleChangeSearchTemplates(e.target.value)}
      placeholder={placeholder}
    />
  );
};

export default SearchInput;

export const Spinner = styled.div`
  display: inline-block;
  margin: 20px;
  width: 50px;
  height: 50px;
  border: 5px solid rgb(3, 3, 3);
  border-radius: 50%;
  border-top-color: rgba(0, 0, 0, 0);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/SearchInput/index.js